module.exports = __webpack_public_path__ + "static/media/Balance-l-female.ce65a010.svg";